import { newColors } from "constants/newColors";
import styled from "styled-components";
import { InterviewType } from "types/graphqlapi";

export const StyledInterviewManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 2rem);
  padding: 1.5rem 1rem 0 1rem;
  box-sizing: border-box;
`;

export const StyledPageNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const StyledHeadline = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  column-gap: 2rem;
  min-height: 300px;
  flex-grow: 1;
`;

export const StyledInterviewListContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  height: 100%;
  box-sizing: border-box;
  min-width: 520px;
`;

export const StyledInterviewDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  flex-grow: 1;
  min-width: min-content;
  height: 100%;
  box-sizing: border-box;
`;
